module.exports = __webpack_public_path__ + "static/img/BANNER_3.2000508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BANNER_3.png
// module id = 79lN
// module chunks = 5